import React, { useEffect, useState, useRef, useMemo } from 'react';
import './CountSheet.css';
import { Breadcrumb, Button, Dropdown, message, Modal, Select, Space, Tooltip } from 'antd';
import { DownOutlined, PlusOutlined, UserOutlined } from '@ant-design/icons';
import AddIcon from '@mui/icons-material/Add';
import PrintRoundedIcon from '@mui/icons-material/PrintRounded';
import CustomTable from '../../CustomTable';
import AddAndEditCountSheet from './AddAndEditCountSheet';
import EditWarningModal from '../../Modal/EditWarningModal';
import { mainAxios } from '../../middleware/interceptor';
import PrintCountSheetTemplate from "../PrintCountSheetTemplate";
import NewCountSheetModal from '../../Modal/NewCountSheetModal';
import { toast } from 'react-toastify';
import dayjs from "dayjs";

const filterItems = [
  { label: 'All Count Sheet', key: '1', },
  { label: 'Active Count Sheet', key: '2', },
  { label: 'Inactive Count Sheet', key: '3', },
];

export const OverallCountSheet = () => {
  const [backupList, setBackupList] = useState([]);
  const [OverallCountSheetList, setOverallCountSheetList] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [addAndEditCountSheet, setAddAndEditCountSheet] = useState(false);
  const [openCountSheetType, setOpenCountSheetType] = useState(true);
  const [countSheetWarningModal, setCountSheetWarningModal] = useState(false);
  const [countSheetData, setCountSheetData] = useState([]);
  const [RestID, setRestId] = useState(localStorage.getItem('RestId'));
  const [isLoading, setIsLoading] = useState(true);
  const [countSheetLabels, setCountSheetLabels] = useState([]);
  const [selectedCountSheetData, setSelectedCountSheetData] = useState([]);
  const [createCountSheetModal, setCreateCountSheetModal] = useState(false);
  const [showWarningModal, setShowWarningModal] = useState(false);
  const [filterValue, setFilterValue] = useState('Active Count Sheet')

  const printRef = useRef(null);

  const handleFilterCountSheet = (e) => {
    const { key } = e;
    setFilterValue(e.domEvent.target.innerText);
    if (key === '1') {
      setOverallCountSheetList(backupList);
    } else if (key === '2') {
      setOverallCountSheetList(backupList.filter(item => item.Status === 1));
    } else if (key === '3') {
      setOverallCountSheetList(backupList.filter(item => item.Status === 0));
    }
  };

  const filterProps = {
    items: filterItems,
    onClick: handleFilterCountSheet
  };

  const handleSelectedLabel = (e) => {
    const filterData = OverallCountSheetList.filter(overAllData => overAllData.CountSheetId === e.key);

    if (filterData.length > 0 && filterData[0]?.InventoryDetails?.length > 0) {
      setSelectedCountSheetData(filterData);
    } else {
      toast.warning('No data to print!');
    }
  };

  const printProps = {
    items: countSheetLabels,
    onClick: handleSelectedLabel,
  };

  const getPrintCousheetLabel = (countsheetLabelList) => {
    const countsheetLabel = countsheetLabelList.filter(item => item.Status === 1).map((countsheetLabel) => {
      return {
        label: countsheetLabel.CountSheetName,
        key: countsheetLabel.CountSheetId,
      };
    });
    setCountSheetLabels(countsheetLabel);
  };

  const estimateColumnWidth = (text, minWidth = 100, maxWidth = 300) => {
    const estimatedWidth = text.length * 10;
    return Math.max(minWidth, Math.min(estimatedWidth, maxWidth));
  };


  let columnDef = [
    {
      accessorKey: 'CountSheetName',
      header: 'Count Sheet Name',
      enableColumnActions: false,
    },
    ...categoryList?.map((cat, index) => (
      {
        accessorKey: cat.toString(),
        header: cat.toString(),
        enableColumnActions: false,
        size: estimateColumnWidth(cat),
      })
    ),
    {
      accessorKey: 'LastCountDate',
      header: 'Last Count Date',
      size: 40,
      enableColumnActions: false,
      Cell: ({ row }) => {
        return (
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            {!!row.original.LastCountDate
              ? dayjs(row.original.LastCountDate).format("MM/DD/YYYY")
              : '-'
            }
          </div>
        )
      }
    },
    {
      accessorKey: 'totalProductCount',
      header: 'Total Line',
      enableColumnActions: false,
      size: 50
    }
  ];
  const columns = useMemo(() => [
    {
      id: 'employee', //id used to define `group` column
      header: 'Number of Products',
      columns: columnDef
    }
  ]);

  const Tableprops = {
    muiTableBodyRowProps: ({ row }) => ({
      onClick: (event) => {
        if (row.original.CurrentInventoryStatus === 0) {
          setShowWarningModal(true);
          return;
        }
        // row.original.Count_Sheet_Name === 'Bar Inventory' ? setCountSheetWarningModal(true) :
        setAddAndEditCountSheet(true);
        setOpenCountSheetType(false);
        setCountSheetData(row.original);
      },
      sx: { cursor: "pointer" },
    }),
  };

  const getCategories = () => {
    mainAxios.get('api/Inventory/Getcategories/' + RestID).then(res => {
      if (res?.data?.hasOwnProperty("Categorydetails")) {
        let categoryList = res?.data?.Categorydetails.map((list) => (list.Cat_name));
        setCategoryList(categoryList);
        getAllCountSheet(categoryList);
      }
    }).catch((err) => {
      setIsLoading(false);
      console.log(err);
    })
  };

  const getAllCountSheet = (categoryList) => {
    mainAxios.get(`api/Inventory/lsitCountsheets?RestId=${RestID}`)
      .then((res) => {
        if (res?.data?.status !== 0) {
          getPrintCousheetLabel(res?.data?.countsheetsList);
          let result = res?.data?.countsheetsList?.map((list) => {
            // Ensure ItemCount is always an array
            let itemCount = typeof list?.ItemCount === "object" ? [list?.ItemCount] : list?.ItemCount;

            // Initialize default category values
            let missingCategory = categoryList.reduce((result, item) => {
              result[item] = 0;
              return result;
            }, {});

            // Populate missingCategory with itemCount values
            for (const name of itemCount) {
              Object.entries(name).forEach(([key, value]) => {
                missingCategory[key] = value;
              });
            }

            // Calculate total count
            let totalCount = Object.values(missingCategory).reduce((total, count) => total + count, 0);

            // Create updated list object
            let updatedList = {
              ...list, // Include original list properties
              ...missingCategory, // Include category values
              lastCountDate: "",
              totalProductCount: totalCount,
              CurrentInventoryStatus: list?.CurrentInventoryStatus ?? 1,
            };

            return updatedList;
          });
          setOverallCountSheetList(result);
          setBackupList(result);
          setIsLoading(false);
        } else {
          setOverallCountSheetList([]);
          setBackupList([]);
          setIsLoading(false);
          console.log("No count sheets available");
        }
      })
      .catch((err) => {
        setIsLoading(false)
        console.log(err);
      });
  };

  const UpdateAllCountSheet = (id) => {
    mainAxios.get(`api/Inventory/lsitCountsheets?RestId=${RestID}`)
      .then((res) => {
        if (res?.data?.status !== 0) {
          getPrintCousheetLabel(res?.data?.countsheetsList);
          let result = res?.data?.countsheetsList?.map((list) => {
            // Ensure ItemCount is always an array
            let itemCount = typeof list?.ItemCount === "object" ? [list?.ItemCount] : list?.ItemCount;
            // Initialize default category values
            let missingCategory = categoryList.reduce((result, item) => {
              result[item] = 0;
              return result;
            }, {});
            // Populate missingCategory with itemCount values
            for (const name of itemCount) {
              Object.entries(name).forEach(([key, value]) => {
                missingCategory[key] = value;
              });
            }
            // Calculate total count
            let totalCount = Object.values(missingCategory).reduce((total, count) => total + count, 0);
            // Create updated list object
            let updatedList = {
              ...list, // Include original list properties
              ...missingCategory, // Include category values
              lastCountDate: "",
              totalProductCount: totalCount
            };
            return updatedList;
          });
          setOverallCountSheetList(result);
          setBackupList(result);
          // setIsLoading(false);
          let filterCountSheetData = res?.data?.countsheetsList?.find((a) => (a.CountSheetId === id))
          setCountSheetData(filterCountSheetData);
        } else {
          setOverallCountSheetList([]);
          setBackupList([]);
          setIsLoading(false);
          console.log("No count sheets available");
        }
      })
      .catch((err) => {
        // setIsLoading(false)
        console.log(err);
      });
  };

  const CreateNewCountSheet = (Name) => {
    let req = {
      "restid": RestID,
      "countsheetName": Name?.trim() || '',
      "countsheetId": "",
      "countsheetDetails": [],
      "canEditCountSheetName": 1
    };

    mainAxios.post(`api/Inventory/addCountsheet`, req).then((res) => {
      if (res?.data?.Status == "1") {
        toast.success('Count Sheet Added Successfully');
        // UpdateCountSheet(countSheetId);
        // setProductModal(false);
        setCreateCountSheetModal(false);
        setIsLoading(true)
        getCategories();
      } else {
        toast.warning(res?.data?.Msg || 'Failed to Add Count Sheet');
        setIsLoading(false)
      }
    }).catch((err) => { console.log(err); setIsLoading(false) })
  };

  useEffect(() => {
    getCategories();
  }, []);

  useEffect(() => {
    handleFilterCountSheet({
      key: '2', domEvent: {
        target: {
          innerText: 'Active Count Sheet'
        }
      }
    });
  }, [backupList]);

  useEffect(() => {
    if (selectedCountSheetData.length > 0 && printRef.current) {
      setTimeout(() => {
        printRef.current.handlePrint();
      }, 500);
    }
  }, [selectedCountSheetData]);

  return (
    <>
      <div className="startinventoryOuter">
        <div className="startinventory" style={addAndEditCountSheet ? { paddingBottom: '0px' } : {}}>
          {!addAndEditCountSheet ? (
            <div>
              <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
                <div style={{ display: 'flex', justifyContent: 'start' }}>
                  <Dropdown
                    menu={filterProps}
                    trigger={['click']}

                  >
                    <Button className='printDropdown'>
                      <Space>
                        {filterValue}
                        <DownOutlined />
                      </Space>
                    </Button>
                  </Dropdown>
                </div>
                <div style={{ display: 'flex', justifyContent: 'start', }}>
                  <div className='filterParent'>
                    <div className='filterChild'>
                      <div>
                        <Button className='printButton' icon={<AddIcon />} onClick={() => { setCreateCountSheetModal(true) }}>
                          <Space>
                            Add Count Sheet
                          </Space>
                        </Button>
                      </div>
                      <div>
                        <Dropdown
                          menu={printProps}
                          trigger={['click']}
                          disabled={isLoading}
                        >
                          <Button className='printDropdown' icon={<PrintRoundedIcon />}>
                            <Space>
                              Print Count Sheet
                              <DownOutlined />
                            </Space>
                          </Button>
                        </Dropdown>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div style={{ marginTop: '10px' }}>
                <div className='CountSheetTable'>
                  <CustomTable
                    data={OverallCountSheetList}
                    columns={columns}
                    enableTopToolbar={false}
                    enableBottomToolbar={false}
                    optionalProps={Tableprops}
                    initialState={{ columnPinning: { left: ['CountSheetName'], right: ['totalProductCount'] } }}
                    isLoading={isLoading}
                  />
                </div>
              </div>
            </div>
          )
            : (
              <AddAndEditCountSheet
                isAdd={openCountSheetType}
                setAddAndEditCountSheet={setAddAndEditCountSheet}
                CountSheetData={countSheetData}
                UpdateCountSheet={UpdateAllCountSheet}

              />
            )}
        </div>

        <EditWarningModal
          visible={countSheetWarningModal}
          setVisible={setCountSheetWarningModal}
        />
        <NewCountSheetModal
          visible={createCountSheetModal}
          setVisible={setCreateCountSheetModal}
          createCountSheet={CreateNewCountSheet}
        />

        <Modal
          title="Cannot Edit Count Sheet!"
          open={showWarningModal}
          onOk={() => setShowWarningModal(false)}
          onCancel={() => setShowWarningModal(false)}
          footer={[
            <Button
              key="submit"
              style={{ backgroundColor: "#2BAB47", color: "#fff" }}
              onClick={() => setShowWarningModal(false)}
            >
              OK
            </Button>,
          ]}
        >
          <p className="addnewcount1">
            There is an inventory in process (not in a closed status). Please close out any open inventories before editing the Count Sheet. You can make any changes you require in the open inventory and those changes will be reflected in your Count Sheet after it is closed.
          </p>
        </Modal>
        {selectedCountSheetData.length > 0 && (
          <div style={{ position: 'absolute', top: -5000, left: -5000 }}>
            <PrintCountSheetTemplate
              ref={printRef}
              countSheetData={selectedCountSheetData}
            />
          </div>
        )}
      </div>
    </>
  );
};
